module.exports = __webpack_public_path__ + "img/btn_HIGH_normal.9ea7aadf.png";